const en: Record<string, string> = {
  'nav.home': 'Home',
  'nav.settings': 'Settings',
  'nav.back': 'Back',

  'login.title': 'Sign in to AetherCasa',
  'login.passkey': 'Sign in with passkey',
  'login.passkey.desc': 'Use your device biometrics or security key',
  'login.email': 'Email magic link',
  'login.email.placeholder': 'you@example.com',
  'login.email.submit': 'Send magic link',
  'login.email.sent': 'Check your email for a sign-in link',
  'login.register': "Don't have an account? Register",
  'login.register.name': 'Display name',
  'login.register.submit': 'Register with passkey',
  'login.error.passkey': 'Passkey sign-in failed',
  'login.error.email': 'Failed to send magic link',

  'common.loading': 'Loading…',
  'common.error': 'Something went wrong',
  'common.retry': 'Retry',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.delete': 'Delete',
  'common.on': 'On',
  'common.off': 'Off',
  'common.unknown': 'Unknown',

  'dashboard.unsorted': 'Unsorted',
  'dashboard.no_devices': 'No devices found',
  'dashboard.bridge_offline': 'Bridge offline',
  'dashboard.bridge_online': 'Bridge online',
  'dashboard.connecting': 'Connecting…',

  'settings.title': 'Settings',
  'settings.theme': 'Theme',
  'settings.theme_mode': 'Mode',
  'settings.light': 'Light',
  'settings.dark': 'Dark',
  'settings.system': 'System',
  'settings.locale': 'Language',
  'settings.accessibility': 'Accessibility',
  'settings.reduced_motion': 'Reduce motion',
  'settings.large_text': 'Large text',
  'settings.high_contrast': 'High contrast',
  'settings.color_blind': 'Color blind mode',
  'settings.homes': 'Homes',
  'settings.account': 'Account',
  'settings.sign_out': 'Sign out',

  'feedback.button': 'Send feedback',
  'feedback.placeholder': "What's on your mind?",
  'feedback.submit': 'Submit',
  'feedback.thanks': 'Thanks for your feedback!',

  'error.no_bridge': 'No bridge connected',
  'error.command_failed': 'Command failed',
  'error.auth_required': 'Please sign in',
};

export default en;
